import React from "react";

import { Grid } from "@material-ui/core";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';

export default function NoticeCategoryForm({
	onCancel,
	onSave,
	fullWidth,
	category,
	saving
}) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});

	const [name, setName] = React.useState("");

	const onChangeName = (e) => {
		category.name = e.target.value.trim();
		setName(e.target.value);
	}

	const ColoredLine = ({ color }) => (
	    <hr
	        style={{
	            color: color,
	            backgroundColor: color,
	            marginTop: 6,
	            marginBottom: 16,
	            height: 2
	        }}
	    />
	);

	return(
 		<Grid container>
	 		<Grid item xs={false} md={ fullWidth ? false : 2} />
	       	<Grid item xs={12} md={ fullWidth ? 12 : 8} >
	       		<Grid container spacing={2}>
	       			<Grid item xs={12}>
						<p style={{ fontSize: '28px', textAlign: 'left'}}>
							{ category.mainCategoryId ? "Nueva subcategoría" : "Nueva categoría" }
						</p>
						<ColoredLine color="gray"/>
						<Grid container spacing={2}>
							<Grid item xs={12} md={true}>
								<Grid item xs={12}>
									<TextField
										required
										variant="outlined"
										id="name"
										label="Nombre"
										name="name"
										onChange={onChangeName}
										disabled={saving}
										value={name}
										fullWidth
										placeholder="Nombre"/>
								</Grid>
			       			</Grid>
						</Grid>
					</Grid>
					{ onCancel || onSave ? (
						<Grid item xs={12}>
							<ColoredLine color="gray"/>
							<Grid container spacing={2}>
								<Grid item xs={true}/>
								<Grid item>
									{ onCancel? (
										<ThemeProvider theme={theme}>
											<Button 
								            	disabled={saving} 
								            	startIcon={<CancelIcon/>} 
								            	variant="contained" 
								            	onClick={onCancel}>
								            	Cancelar
								            </Button>
								        </ThemeProvider>) : (null)
							        }
								</Grid>
								<Grid item>
									{ onSave ? (
										<LoadingButton
											disabled={!(category.name && category.name.trim())}
								            loadingPosition="start"
								            startIcon={<DoneIcon />}
								            loading={saving}
								            variant="contained"
								            onClick={onSave}>
								            <b>Crear</b>
						          		</LoadingButton>) : (null)
					          		}
								</Grid>
							</Grid>
						</Grid>) : (null)
					}
	       		</Grid>
	       	</Grid>
	   		<Grid item xs={false} md={ fullWidth ? false : 2} />
		</Grid>
	)

}
